module.exports = __webpack_public_path__ + "img/user-experience-interface-design.b81f20fc.jpg";